module.exports = __webpack_public_path__ + "img/金币灰色.828d700e.png";